export default __webpack_public_path__ + "static/media/ronictijo.e8449dd0.jpg";